const FLIP_DURATION = 200;

function flipIcon(icon, toMinus) {
    icon.classList.remove('faq__item-icon--spinning');
    void icon.offsetWidth; // reflow to restart animation
    icon.style.animationDirection = toMinus ? 'normal' : 'reverse';
    icon.classList.add('faq__item-icon--spinning');

    icon.addEventListener('animationend', () => {
        icon.classList.remove('faq__item-icon--spinning');
        icon.style.transform = '';
    }, { once: true });
}

document.addEventListener('DOMContentLoaded', function () {
    const faqAccordion = document.querySelector('.faq__accordion');
    if (!faqAccordion) return;

    const setItemState = (item, isActive, shouldAnimate = true) => {
        item.classList.toggle('faq__item--active', isActive);

        const trigger = item.querySelector('.faq__item-title');
        const answer = item.querySelector('.faq__item-answer');
        const icon = trigger ? trigger.querySelector('.faq__item-icon') : null;

        if (trigger) {
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (answer) {
            answer.hidden = !isActive;
        }

        if (icon && shouldAnimate) {
            flipIcon(icon, isActive);
        }
    };

    faqAccordion.querySelectorAll('.faq__item').forEach(item => {
        setItemState(item, item.classList.contains('faq__item--active'), false);
    });

    faqAccordion.addEventListener('click', function (e) {
        const title = e.target.closest('.faq__item-title');
        if (!title) return;
        const index = title.dataset.index;
        const items = faqAccordion.querySelectorAll('.faq__item');

        items.forEach(item => {
            const itemTitle = item.querySelector('.faq__item-title');
            if (!itemTitle) return;

            if (itemTitle.dataset.index === index) {
                const isOpening = !item.classList.contains('faq__item--active');
                setItemState(item, isOpening);
            } else if (item.classList.contains('faq__item--active')) {
                setItemState(item, false);
            }
        });
    });
});
